import React from "react";
import TradeDialogDesktop from "./TradeDialogDesktop.jsx";
import TradeDialogMobile from "./TradeDialogMobile.jsx";

const TradeDialog = (props) => {

  const renderMobileTradeDialog = () => {
    return (
      <>
        <TradeDialogMobile
          loggedInUserData={props.loggedInUserData}
          eid={props.eid}
          isAdmin={props.isAdmin}
          isAdminPage={props.isAdminPage}
          trade={props.trade}
          isDialogOpen={props.isDialogOpen}
          onClickDialogOpen={props.handleClickDialogOpen.bind(this)}
          onClickDialogClose={props.handleClickDialogClose.bind(this)}
        />
      </>
    );
  };

  const renderDesktopTradeDialog = () => {
    return (
      <>
        <TradeDialogDesktop
          loggedInUserData={props.loggedInUserData}
          eid={props.eid}
          isAdmin={props.isAdmin}
          isAdminPage={props.isAdminPage}
          trade={props.trade}
          isDialogOpen={props.isDialogOpen}
          onClickDialogOpen={props.handleClickDialogOpen.bind(this)}
          onClickDialogClose={props.handleClickDialogClose.bind(this)}
        />
      </>
    );
  };

  return (
    <div>
      {props.isDialogOpen ? <div>{props.isDesktopView ? renderDesktopTradeDialog() : renderMobileTradeDialog()}</div> : ""}
    </div>
  );
};

export default TradeDialog;
